import React from 'react';
import { useTranslation } from 'react-i18next';
import { translateDateFilterValue } from '../../helpers/dateHelpers';
import FilterValueWrapper, { FilterValuesProps } from './FilterValueWrapper';

export const DateFilterValues = ({
    singleFilter,
}: FilterValuesProps): React.ReactElement<FilterValuesProps> => {
    const { t } = useTranslation('sentence');
    const translatedValue = translateDateFilterValue(t, singleFilter);
    return <FilterValueWrapper>{translatedValue} </FilterValueWrapper>;
};
